import { waitFor } from '../../CodesThatsGottaGoSomewhereElse';
import { ApiCall, ApiClient } from '../ApiClient';
import { v2 } from '../ApiInterfaceV2';

const get = <TResponse>(def: Omit<ApiCall<never, TResponse>, 'method'>): ApiCall<never, TResponse> =>
    Object.assign(def, { method: 'get' });

const post = <TResponse>(def: Omit<ApiCall<any, TResponse>, 'method'>): ApiCall<any, TResponse> =>
    Object.assign(def, { method: 'post' });

export interface OperationData {
    operationId: string;
    status: string;
    message: string;
    tasks: {
        current: string,
        total: number,
        remaining: number,
    };
}

export const operationsEndpoints = {

    info: (operationId: string) => get<OperationData>({
        path: '/operations.info',
        query: { operationId },
    }),

};

export const waitForOperation = async (api: ApiClient, operationId: string) => {

    for (let i = 0; i < 1000; i++) {
        const { status } = await api.exec(v2.operations.info(operationId));
        if (status === 'COMPLETED') return true;
        if (status === 'FAILED') return false;
        await waitFor(500);
    }

    return false;
};
